<template>
<div id="page-offline" class="container">
    <div class="row">
    	<div class="col-xs-12 text-center text">
    		<img src="img/no-internet.png">
    		<h3>No internet connection</h3>
    		<p>Make sure <i>Wifi or cellular data</i> is turned on and then try again.</p>

			<loader v-if="loading" color="ripple" size="100px" style="margin-top: -25px;"></loader>
    		<div class="btn btn-retry button" @click="retry()" v-else>Try again</div>
    	</div>
    </div>
</div>
</template>

<script>
export default {
    components: {
    	'loader': require('@/components/Loader.vue').default,
    },

    data() {
        return {
        	loading: false
        }
    },

    activated(){
    	this.loading = false;
    },

    mounted() {
    	window.backOnline = () => {
    		this.$router.push(localStorage.offlineUrl);
    	}		
    },

    methods: {
    	retry(){
    		this.loading = true;
    		window.backOnline();
    		window.addEventListener('online', backOnline);

    		setTimeout(() => {
    			this.loading = false;
    			window.removeEventListener('online', backOnline);
    		}, 10000);
    	}
    },

    beforeDestroy() {
        window.removeEventListener('online', backOnline);
    }
}
</script>